import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconFlagFR = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  const iconTitle = title ?? 'France'
  const iconSize = size ?? 16
  const iconColor = color ?? theme.colors.contentPrimary

  return (
    <Icon viewBox="0 0 24 24" ref={ref} title={iconTitle} size={iconSize} color={iconColor} overrides={overrides}>
      <title>{iconTitle}</title>
      <rect x="3" y="6" width="18" height="12" rx="2" fill="#FFFFFF" />
      <rect x="3" y="6" width="6" height="12" rx="2" fill="#1F4FBF" />
      <rect x="15" y="6" width="6" height="12" rx="2" fill="#E22D2D" />
      <rect x="3" y="6" width="18" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.35" />
    </Icon>
  )
}

IconFlagFR.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconFlagFR
